export { MedicalCoverageType } from './generated/MedicalCoverageType.js';